import { render, staticRenderFns } from "./DialogUser.vue?vue&type=template&id=9bf1a45c&"
import script from "./DialogUser.vue?vue&type=script&lang=ts&"
export * from "./DialogUser.vue?vue&type=script&lang=ts&"
import style0 from "./DialogUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports